import {filter, join, length, lt, match, pipe, toLower} from 'ramda'

export const SET_WORD = 'SET_WORD'
export const SHARE_WORD_START = 'SHARE_WORD_START'
export const SHARE_WORD_DONE = 'SHARE_WORD_DONE'
export const SHARE_WORD_COPY = 'SHARE_WORD_COPY'
export const SHARE_STATUS_HIDE = 'SHARE_STATUS_HIDE'

const initialState = {
  word: '',
  shareStatus: '',
  showShareStatus: false,
  isSharing: false,
}

export function createGame(state = initialState, action) {
  switch (action.type) {
    case SET_WORD: {
      const {word} = action
      return {...state, word: cleanInputWord(word), showShareStatus: false}
    }
    case SHARE_WORD_START: {
      return {...state, isSharing: true}
    }
    case SHARE_WORD_DONE: {
      const {shareStatus} = action
      return {...state, isSharing: false, shareStatus, showShareStatus: true}
    }
    case SHARE_WORD_COPY: {
      const {shareStatus} = action
      return {...state, shareStatus, showShareStatus: true}
    }
    case SHARE_STATUS_HIDE: {
      return {...state, showShareStatus: false}
    }
    default:
      return state
  }
}

const filterLetters = filter(pipe(match(/[a-z]/), length, lt(0)))

const cleanInputWord = pipe(toLower, filterLetters, join(''))
